import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/heektime-notice-web/heektime-notice-web/src/components/layout/layout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Layout = makeShortcode("Layout");
const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Layout mdxType="Layout">
      <h1>{`Apple Watch 지원`}</h1>
      <p>{`안녕하세요, HeekTime 3.5.0 버전부터 Apple Watch를 지원합니다. Apple Watch용 HeekTime은 iOS 앱과 함께 사용할 수 있습니다.`}</p>
      <br />
      <h3>{`컴플리케이션`}</h3>
      <div style={{
        "maxWidth": "180px",
        "margin": "0 auto"
      }}>
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "360px"
            }
          }}>{`
      `}<a parentName="span" {...{
              "className": "gatsby-resp-image-link",
              "href": "/static/321eb3bfd61616c7736f3399195dd055/7a322/module.png",
              "style": {
                "display": "block"
              },
              "target": "_blank",
              "rel": "noopener"
            }}>{`
    `}<span parentName="a" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "109.70588235294116%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block"
                }
              }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/static/321eb3bfd61616c7736f3399195dd055/428d3/module.avif 340w", "/static/321eb3bfd61616c7736f3399195dd055/193c9/module.avif 360w"],
                  "sizes": "(max-width: 360px) 100vw, 360px",
                  "type": "image/avif"
                }}></source><source parentName="picture" {...{
                  "srcSet": ["/static/321eb3bfd61616c7736f3399195dd055/3b4fb/module.webp 340w", "/static/321eb3bfd61616c7736f3399195dd055/97ead/module.webp 360w"],
                  "sizes": "(max-width: 360px) 100vw, 360px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/static/321eb3bfd61616c7736f3399195dd055/db006/module.png 340w", "/static/321eb3bfd61616c7736f3399195dd055/7a322/module.png 360w"],
                  "sizes": "(max-width: 360px) 100vw, 360px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/static/321eb3bfd61616c7736f3399195dd055/7a322/module.png",
                  "alt": "HeekTime 현재 강의 컴플리케이션 스크린샷",
                  "title": "HeekTime 현재 강의 컴플리케이션 스크린샷",
                  "loading": "lazy",
                  "decoding": "async",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
      </div>
      <p>{`애플 워치 페이스에서 사용할 수 있는 현재 강의 정보 컴플리케이션을 제공합니다.
현재 강의 컴플리케이션은 현재 진행 중인 수업 정보와 남은 시간 또는 예정된 수업에 대한 정보를 보여줍니다.`}</p>
      <Link to="/contents/watch-faces" mdxType="Link">페이스 갤러리</Link>에서 컴플리케이션을 살펴보고
예제 페이스를 바로 적용해보세요.
      <br />
      <br />
      <h3>{`Watch 앱`}</h3>
      <div style={{
        "maxWidth": "180px",
        "margin": "0 auto"
      }}>
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "458px"
            }
          }}>{`
      `}<a parentName="span" {...{
              "className": "gatsby-resp-image-link",
              "href": "/static/8e3a67b016d6eb9b79cb469a39ef9806/ff903/watchapp.png",
              "style": {
                "display": "block"
              },
              "target": "_blank",
              "rel": "noopener"
            }}>{`
    `}<span parentName="a" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "112.6470588235294%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block"
                }
              }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/static/8e3a67b016d6eb9b79cb469a39ef9806/428d3/watchapp.avif 340w", "/static/8e3a67b016d6eb9b79cb469a39ef9806/06827/watchapp.avif 458w"],
                  "sizes": "(max-width: 458px) 100vw, 458px",
                  "type": "image/avif"
                }}></source><source parentName="picture" {...{
                  "srcSet": ["/static/8e3a67b016d6eb9b79cb469a39ef9806/3b4fb/watchapp.webp 340w", "/static/8e3a67b016d6eb9b79cb469a39ef9806/440c5/watchapp.webp 458w"],
                  "sizes": "(max-width: 458px) 100vw, 458px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/static/8e3a67b016d6eb9b79cb469a39ef9806/db006/watchapp.png 340w", "/static/8e3a67b016d6eb9b79cb469a39ef9806/ff903/watchapp.png 458w"],
                  "sizes": "(max-width: 458px) 100vw, 458px",
                  "type": "image/png"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/static/8e3a67b016d6eb9b79cb469a39ef9806/ff903/watchapp.png",
                  "alt": "HeekTime Watch 앱 스크린샷",
                  "title": "HeekTime Watch 앱 스크린샷",
                  "loading": "lazy",
                  "decoding": "async",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
      </div>
      <p>{`Watch 앱에서는 간단히 시간표를 조회할 수 있습니다.`}</p>
      <br />
      <p>{`문의: `}<a href="mailto:heektime@heek.kr"><a parentName="p" {...{
            "href": "mailto:heektime@heek.kr"
          }}>{`heektime@heek.kr`}</a></a></p>
    </Layout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      